/**
 * @file deafHardOfHearing.js
 * @author Jake Stark
 * @desc deafHardOfHearing report plugin

*/

/**
 * @module deafHardOfHearing 
 * @desc deafHardOfHearing report plugin
 */

define('plugins/deafHardOfHearing',["underscore",
        "models", "cardboard/models", "cardboard/collections", "cardboard/util", "cardboard/pluginPieces", "text!plugins/templates/deafHardOfHearing_partByProg_table.html!strip", "text!plugins/templates/deafHardOfHearing_3rdGrAchievement_table.html!strip", "text!plugins/templates/deafHardOfHearing_proficiencyIdentification_table.html!strip", "text!plugins/templates/deafHardOfHearing_proficiencyHearingLoss_table.html!strip"
    ],
    function(_,
        ECLDSModels, CardboardModels, CardboardCollections, Util, PluginPieces,
        partByProgTemplate, achieveTemplate, proficiencyIdentificationTableTemplate, proficiencyHearingLossTableTemplate) {

        console.log("MODULE: deafHardOfHearing");

      //  var FY = location.hash.substring(location.hash.indexOf("FISCAL_YEAR--") + 13, location.hash.indexOf("FISCAL_YEAR--") + 17);

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                noOrgFinderSchool: true,
                orgFinderDistrict: true,
                forcedSummaryFilters: ["FISCAL_YEAR", "SUBJECT", "RACE_ETHTYPE"],
                definitionsECLDS: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "D/HH Participation by Program",
                    explanationText: "<p>This chart shows the percent of children who are deaf or hard of hearing (D/HH), reported to Minnesota Department of Health's (MDH) Early Hearing Detection and Intervention (EHDI) program who have ever participated in early care and education programs. </p><p>Data in the chart may not be complete for children born in 2007, legislation for mandatory reporting was passed in the spring of 2007. </p>",
                    openByDefault: true,

                    views: [{
                            type: "template",
                            template: "NOTE:  Data includes children reported to MDH's EHDI program who have some degree of hearing loss. </p> <button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                        }, 
                        {
                            type: "template",
                            template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                            dataSourceName: "data",
                            dataPath: "dataSets.DHHParticipationByProgram"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataSetPath: "dataSets.DHHParticipationByProgram",
                            yAxisMax: 100,
                            title: "",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,

                            // DISPLAY
                            // xAxisLabelPath: "label",
                            unitString: "%",
                            showLegend: false,
                            colorByPoint: true,
                            unitDec: 1,
                            disableLegendClick: false,
                            exportToPDF: true,
                            hideContext: true,

                            // SERIES
                            series: [{
                                seriesDisplayNamePath: "program",
                                // seriesDisplayName: "programName",
                                dataPath: "",
                                valuePath: "percent",
                                displayNamePath: "program",
                             //   colors: ["orange", "orange", "orange", "orange"],

                            }],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },

                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "dataSets.DHHParticipationByProgram",
                            template: partByProgTemplate,
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                }, {
                title: "D/HH 3rd Grade Achievement",
                explanationText: "<p>This chart shows 3rd grade achievement levels for children who are deaf or hard of hearing reported to MDH’s EHDI program.</p><p>The tests given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes in tested standards. Children who did not take the test are not included in this chart or the statewide average.  If child repeated 3rd grade and took more than one test, the most recent test score is included here.</p> <p>Data in the chart may not be complete for children born in 2007, as legislation for mandatory reporting to the Department of Health was passed in the spring of 2007.</p><p>More information about the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=MDE034819&RevisionSelectionMethod=latestReleased&Rendition=primary'  target='_blank'>public programs included in ECLDS</a> is available.</p>",
                openByDefault: false,

                views: [{
                    type: "template",
                    template: "<p class='red'>Due to COVID-19, no 2020 summarized assessment data for MCA or MTAS is available.</p> <p>NOTE: Data includes children reported to MDH’s EHDI program who have some degree of hearing loss. </p><p>NOTE: For the 2020-21 school year, the participation rates for both math and reading assessments in 3rd grade was 85%. Historically, the participation rates were higher than 95%. Visit the Minnesota Report Card for more information about 3rd graders’ <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--R__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>reading test participation</a> or <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--M__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>math test participation</a> in your area. </p><button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                }, 
                {
                    type: "template",
                    template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                    dataSourceName: "data",
                    dataPath: "dataSets.DHH3rdGradeAchievement"
                },
                {
                    // SETUP
                    type: "stackedColumn",
                   dataSourceName: "data",
                    dataSetPath: "dataSets.DHH3rdGradeAchievement",

                    // "pointsWithinRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "row", like so:
                    //	 +---------+
                    //	 | X X X X |
                    //	 | . . . . |
                    //	 | . . . . |
                    //	 | . . . . |
                    //	 +---------+
                   dataShape: "pointsAcrossRows",
							convertDataHashToArray: true,
							dataDimensions: 1,

                    // DISPLAY
                    unitString: "%",
       				xAxisLabelPath: "[0].program",

                    showLegend: true,
                    disableLegendClick: false,
                    exportToPDF: true,
                    hideContext: true,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        //valuePath: "[0].percent",
                        seriesDisplayName: "Exceeds",
                        valuePath: "[0].percent",
                    }, {
                        seriesDisplayName: "Meets",
                        valuePath: "[1].percent",
                    },{
                        seriesDisplayName: "Partially Meets",
                        valuePath: "[2].percent",
                    },{
                        //valuePath: "[0].percent",
                        seriesDisplayName: "Doesn't Meet",
                        valuePath: "[3].percent",
                    },                   ],
                    errorConditions: [PluginPieces.standardErrorCondition]
                },
                {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.DHH3rdGradeAchievement",
                    template: achieveTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }]
            },
           /* {
                title: "3rd Grade Proficiency by Age of Identification",
                explanationText: "<p>This chart shows 3rd grade proficiency scores for children who are deaf or hard of hearing reported to MDH’s EHDI program by age of identification, by 90 days of age or greater than 90 days of age.  Identification of hearing loss by 90 days of age is a <a href='http://pediatrics.aappublications.org/content/120/4/898.full?ijkey=oj9BAleg21OIA&keytype=ref&siteid=aapjournals' target='_blank'>national goal of the EHDI program.</a></p><p>Data includes all children reported to MDH newly identified with a hearing loss and includes children who may have had normal hearing at birth and developed hearing loss later. </p> <p>The proficiency tests given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes in tested standards. Children who did not take the proficiency test are not included in this chart. Data in the chart may not be complete for children born in 2007, legislation for mandatory reporting was passed in the spring of 2007.</p>",
                openByDefault: false,

                views: [ {
                    type: "template",
                    template: "<p>NOTE: Data includes children reported to MDH’s EHDI Program whose hearing loss was identified by 90 days of age or greater than 90 days of age. </p><button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.children[0].id);'>Export to PDF</button>"
                }, {
                    // SETUP
                    type: "stackedColumn",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByAgeOfIdentification",

                    // "pointsAcrossRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "column", like so:
                    //	 +---------+
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 +---------+
                    // To wrap your head around this, watch iteration in your debugger in
                    // pointsAcrossRows() in transforms.js.
                    dataShape: "pointsAcrossRows",
                    convertDataHashToArray: true,
                    dataDimensions: 2,
                   // unitDec: 1,
                    title: "",

                    // DISPLAY
                    xAxisLabelPath: "ageOfIdentification",
                    legendReversed: false,
                    unitString: "%",
                    exportToPDF: true,
                    hideContext: true,
                    stackLabels: false,

                    showLegend: true,
                    disableLegendClick: false,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        valuePath: "legend[0].percent",
                        seriesDisplayName: "Not Proficient",
                    }, {
                        valuePath: "legend[1].percent",
                        seriesDisplayName: "Proficient",
                    }],
                    errorConditions: [PluginPieces.standardErrorCondition]
                }, {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByAgeOfIdentification",
                    template: proficiencyIdentificationTableTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }]
            },*/
            {
                title: "3rd Grade Proficiency by Degree of Hearing Loss",
                explanationText: "<p>This chart shows 3rd grade proficiency scores for children who were identified through Newborn Screening as are deaf or hard of hearing and reported to MDH’s EHDI program. Children are grouped into those identified, by 90 days of age and those identified after 90 days of age. Identification of congenital hearing loss by 90 days of age is a <a href='http://pediatrics.aappublications.org/content/120/4/898.full?ijkey=oj9BAleg21OIA&keytype=ref&siteid=aapjournals'>national goal of the EHDI program</a>.</p><p>Data include all children identified through Newborn Screening as deaf or hard of hearing and reported to MDH. Data exclude children who had normal or unknown hearing status at birth and were identified as deaf or hard of hearing later.  </p> <p>The proficiency tests given in 3rd grade are the Minnesota Comprehensive Assessment (MCA) and Minnesota Test of Academic Skills (MTAS). In 2011 math test standards changed and in 2013 reading test standards changed. No comparisons should be made with data before and after the changes in tested standards. Children who did not take the proficiency test are not included in this chart. Data in the chart may not be complete for children born in 2007, legislation for mandatory reporting was passed in the spring of 2007.</p>",
                openByDefault: false,

                views: [ {
                    type: "template",
                    template: "<p class='red'>Due to COVID-19, no 2020 summarized assessment data for MCA or MTAS is available.</p> <p>NOTE:  Degree of hearing loss refers to the unaided severity of the child’s hearing loss as reported by the child’s audiologist.  This data includes children reported to MDH’s EHDI program who have some degree of hearing loss ranging from slight to profound in one or both ears. </p><p>NOTE: For the 2020-21 school year, the participation rates for both math and reading assessments in 3rd grade was 85%. Historically, the participation rates were higher than 95%. Visit the Minnesota Report Card for more information about 3rd graders’ <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--R__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>reading test participation</a> or <a href='https://rc.education.mn.gov/#assessmentsParticipation/orgId--999999000000__groupType--state__test--allAccount__subject--M__accountabilityFlg--FOC_NONE__year--trend__grade--03__p--124' target='_blank'>math test participation</a> in your area. </p><button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.nextSibling.children[0].id);'>Export to PDF</button>"
                }, 
                {
                    type: "template",
                    template: "<h5 class='chartHead'>{{data.heading3}}</h5>",
                    dataSourceName: "data",
                    dataPath: "dataSets.thirdGradeProficiencyByDegreeOfHearingLoss"
                },
                {
                    // SETUP
                    type: "stackedColumn",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByDegreeOfHearingLoss",

                    // "pointsAcrossRows": given that the data is
                    // two-dimensional (meaning an array of arrays, or
                    // similar structure, implying that we have more than
                    // one series to plot) each series is contained in a
                    // "column", like so:
                    //	 +---------+
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 | X . . . |
                    //	 +---------+
                    // To wrap your head around this, watch iteration in your debugger in
                    // pointsAcrossRows() in transforms.js.
                    dataShape: "pointsAcrossRows",
                    convertDataHashToArray: true,
                    dataDimensions: 2,
                   // unitDec: 1,
                    title: "",

                    // DISPLAY
                    xAxisLabelPath: "degreeOfHearingLoss",
                    legendReversed: false,
                    unitString: "%",
                    exportToPDF: true,
                    hideContext: true,
                    stackLabels: false,

                    showLegend: true,
                    disableLegendClick: false,

                    // SERIES (only one series, this is a simple graph)
                    series: [{
                        valuePath: "legend[0].percent",
                        seriesDisplayName: "Not Proficient",
                    }, {
                        valuePath: "legend[1].percent",
                        seriesDisplayName: "Proficient",
                    }],
                    errorConditions: [PluginPieces.standardErrorCondition]
                }, {
                    type: "template",
                    dataSourceName: "data",
                    dataSetPath: "dataSets.thirdGradeProficiencyByDegreeOfHearingLoss",
                    template: proficiencyHearingLossTableTemplate,
                    errorConditions: [PluginPieces.silentStandardErrorCondition]
                }]
            },
            {
                title: "For More Information",
                visibleByDefault: true,
                openByDefault: false,
                views: [{
                    type: "template",
                    template: "<p> These charts show experiences and educational results of children who are Deaf/Hard of Hearing (D/HH) and reported to the Minnesota Department of Health’s (MDH) Early Hearing Detection and Intervention (EHDI) Program.   The population represented in EHDI data is quite small. Three-year cohorts at a strictly statewide level are utilized in the ECLDS to avoid suppression.</p><p>MDH’s EHDI Program ensures infants are receiving appropriate and timely services, including screening (the initial test of infants for hearing loss), audiological diagnostic evaluations (to confirm hearing loss), and early intervention (including medical services, early intervention programs, and family support) to enhance language, communication, cognitive and social skill development. When a child, ages 0-10, is newly identified as D/HH, audiologists send MDH a report with information about the initial diagnosis including the type, severity, and laterality of the hearing loss. </p><p>Occasionally we also receive updates from audiologists about changes in diagnosis, but collection of ongoing audiological management data is not yet routine for the MDH EHDI program.  For many children, the severity of hearing loss will change over time. The diagnostic data presented here represents the most current data obtained by MDH, but note that for most children this is the initial diagnostic information.</p><p>In May 2007, legislation (Minnesota Statutes 144.966) was enacted that mandated reporting of newborn hearing screening results and added hearing loss to the panel of more than 50 rare conditions for which every newborn in Minnesota is screened. This legislation also requires professionals who conduct diagnostic procedures to confirm hearing loss to report the results to parents, primary care providers and MDH. Data in the charts may not be complete for children born in 2007, as legislation for mandatory reporting was only required for part of 2007.</p><h2> Glossary</h2><p><strong> CTSTR</strong>: Counts Too Small To Report – when results are less than 10.<br/><strong> No Data Available</strong>: No data is available for the selected criteria.<br/><strong>Proficient</strong>: Students who are meeting or exceeding academic standards. <br/><strong>Not Proficient</strong>: Students not yet meeting academic standards.<br/><strong>Doesn’t Meet</strong>: Doesn't meet academic standards.<br/><strong>Partially Meets</strong>: Partially meets academic standards.<br/><strong>Meets</strong>:  Meets academic standards.<br/><strong>Exceeds</strong>: Exceeds academic standards. <br/><strong>Degree of Hearing Loss</strong>:  Degree of hearing loss refers to the severity of the child’s hearing loss as reported by audiologist. <ul><li><strong>All D/HH</strong>:  Children who have some degree of hearing loss ranging from slight to profound in one or both ears. </li> <li><strong>Unilateral</strong>: Hearing is normal in one ear but there is hearing loss in the other ear. The hearing loss can range from slight to profound as reported by audiologist.   </li> <li><strong>Slight to Moderate</strong>: Slight to moderate degree or severity of hearing loss as reported by audiologist.    </li> <li><strong> Moderately Severe to Profound</strong>:  Moderately Severe to profound severity of hearing loss as reported by audiologist. </li></ul> </p> <h2>Selection Criteria Definitions</h2><p><strong> School Year</strong>: Period of time that covers July 1 of one year through June 30 of the following.<br/><b>Proficiency Subject - Reading</b>: Standards-based accountability assessments on the English/language arts reading standards in 3rd grade.<br/><b>Proficiency Subject - Math</b>: Standards-based accountability assessments on the mathematics standards in 3rd grade.<br/><strong>Early Childhood Special Education</strong>: (ECSE) provides supports and services to infants, toddlers and preschool children with disabilities and their families. Child received services at any time.   <ul><li><strong>Part B Only</strong> - children with disabilities who received special education services after age three but not before age three. </li> <li><strong>Part C only</strong> -children with disabilities who received special education services before age three but not after age three. </li> <li><strong>  Part B and Part C</strong> - children with disabilities who received special education services before age three and after age three. </li> <li><strong> Neither Part B or Part C </strong>– children with hearing loss who did not receive special education services</li> </ul> </p><p><strong>Race/Ethnicity:</strong><ul style='margin-top: -7px; margin-bottom: -15px;'><li>Federal Race/Ethnicity categories are as reported by the child's education record and align with the federal <a href='https://www.govinfo.gov/content/pkg/FR-1997-10-30/pdf/97-28653.pdf' target='_blank'>Office of Management and Budget’s standards</a>.</li><li>State Race/Ethnicity categories are as follows:<ul style='padding-left: 1em;'><li  style='list-style: circle;'><strong>State (Minnesota) Definition of American Indian</strong>: A person having origins in any of the original peoples of North America and who maintains cultural identification through tribal affiliation or community recognition. Any student or descendant from a North American tribe, regardless of other racial backgrounds.</li><li  style='list-style: circle'><strong>State (Minnesota) Definition of Other Indigenous Peoples</strong>: A student whose only racial or ethnic identification is with the original peoples of Central or South America. A student who meets the federal definition of American Indian or Alaska Native but not the state definition of American Indian, which means they identify only with indigenous peoples from Central and South America.</li><li style='list-style: circle'>State (Minnesota) definitions of race/ethnicity other than American Indian and Other Indigenous Peoples align with federal categories</li></ul></li></ul></p><p><b>504 Accommodation Plan</b>: A 504 Accommodation Plan is written for students with physical or mental impairments that limit one or more life activities. All accommodations, modifications or services must be provided to the student to ensure an education in the least restrictive environment.<br/><b>K-3 Special Education</b>: Students receiving special education services anytime in kindergarten through 3rd grade.<br/><b>Child Protection Involvement</b>: Child Protection involvement means the identified child was in a family where a child protection response was completed. A child protection response is completed when an allegation of child abuse (maltreatment) by parents/caretakers in is determined to meet statutory guidelines for a child protection assessment or investigation. Child protection intervenes with families, according to Minnesota State Statute and the <a href='https://edocs.dhs.state.mn.us/lfserver/Public/DHS-5144-ENG'  target='_blank'>Minnesota Child Maltreatment Screening Guidelines</a>, to address family functioning issues and ensure that child victims of maltreatment are safe.</p><p> For more information, open the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde034818&RevisionSelectionMethod=latestReleased&Rendition=primary'  target='_blank'>ECLDS Data Guide. </a></p>"
                }]
            }],

            filterSources: {
               orgs: {
                    modelType: ECLDSModels.ECLDSOrgList,
                    //url: "/data/state.json",
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_orgid_economicfoodassistance.fex",
                    noViewParams: true,
                    enabled: true
                },

                filters: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_fiscal_year2015.fex",
                       defaultParams: ["FISCAL_YEAR=2016"],
                       filterParam: {
                          fiscalYear: "2016"
                       },
                    enabled: false,
                    modelType: CardboardModels.FilterData
                },

                filters2: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    //   filterParam: {
                    //       fiscalYear: "2015"
                    //   },
                       defaultParams: ["FISCAL_YEAR=2016"],
                    urls: {
                        //filterForReport: "data/filters.json"
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_deafHardOfHearing.fex"
                    },

                    // specify the order of filters, by name (filterUrl in database terms)
                   // filterOrder: ["GENDER", "RACE_ETHNICITY", "OTHER_CRITERIA"],

                    enabled: true,
                    noViewParams: false
                },

                demographicCategories: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_deafHardOfHearing_nbr2.fex",
                    enabled: true,
                    modelType: CardboardCollections.DemoCatProducer,
                    noViewParams: false
                }
            },

            dataSources: {
                data: {
                    modelType: CardboardModels.Model,
                    // url: "/data/mocks/preGradData.json",
                    // url: "/data/mocks/preGradData_statewide.json",
                    url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_sec_o_deafHardOfHearing.fex",
                    yearPath: "meta.fiscalYear",
                    //  defaultParams: {
                    //	orgId: 999999000,
                    //      COHORTID: 2014
                    //	},
                    enabled: true,
                    errorConditions: [PluginPieces.standardErrorCondition]

                }

            }
        };

        return exports;
    });
